import {
    DUMMY_USER,
    SET_USER,
    SET_USERNAME,
    SHOW_ALERT,
    SIGN_IN,
    UPDATE_TOKEN,
    SET_CH_TOKEN,
} from '@/store/types/mutation-types';
import {
    AUTHENTICATE,
    GET_USER,
    GET_USERNAME,
    LOGOUT,
    POLL_CONNECTIVITY,
} from '@/store/types/action-types';
import * as service from '@/sitecore/sitecore-data-service';

import mgr from '@/store/user-manager';

const userState = {
    state: {
        user: {},
        isAuthenticated: false,
        polling: null,
        username: '',
        chToken: '',
    },

    getters: {},

    mutations: {
        [SET_USER](state, { user }) {
            state.user = user;
            state.isAuthenticated = true;

            const roles = user.profile.role;

            if (
                user.profile['http://www.sitecore.net/identity/claims/isAdmin']
                || (roles && roles.map(r => r.toLowerCase()).includes('sitecore\\flex developer'))
            ) {
                state.user.admin = true;
                state.user.designer = true;
                return;
            }

            if (roles && roles.map(r => r.toLowerCase()).includes('sitecore\\flex designer')) {
                state.user.designer = true;
            }
        },

        [SET_USERNAME](state, username) {
            state.username = username;
        },

        [SIGN_IN]() {
            const opts = { state: window.location.href };

            mgr.signinRedirect(opts);
        },

        [DUMMY_USER](state) {
            const dummyUser = { profile: { name: 'Dev' } };
            state.user = dummyUser;
            state.user.admin = true;
            state.user.designer = true;
            state.isAuthenticated = true;
        },

        [UPDATE_TOKEN](state, { token, expiresAt }) {
            state.user.access_token = token;
            state.user.expires_at = expiresAt;
        },

        [SET_CH_TOKEN](state, token) {
            state.chToken = token;
        },
    },
    actions: {
        async [POLL_CONNECTIVITY]({ commit, state }) {
            // poll expiration token
            const difference = new Date(state.user.expires_at * 1000) - new Date();
            const resultInMinutes = Math.round(difference / 60000);

            if (resultInMinutes < 0) {
                // expired, force manual signin anyway
                window.location.href = '/signin';
                return;
            }

            if (resultInMinutes < 5) {
                // show expiration popup, confirm auto signin
                window.location.href = '/signin';
                return;
            }

            // poll server status with random authenticated get call
            const response = await service.getUsername();

            if (response.status === service.ERROR) {
                if (String(response.error).includes('403')) {
                    commit(SHOW_ALERT, {
                        description: 'Error authenticating with Sitecore. In 5 seconds, a new signin window will open to refresh your authentication.',
                    });

                    window.setTimeout(() => {
                        window.location.href = '/signin';
                    }, 6000);
                }
            }
        },

        async [AUTHENTICATE]({ dispatch, commit }) {
            const user = await dispatch(GET_USER); // see if the user details are in session
            if (user) {
                commit(SET_USER, { user });
                await dispatch(GET_USERNAME);
            } else {
                commit(SIGN_IN);
            }
        },

        async [GET_USER]() {
            const user = await mgr.getUser();
            return user;
        },

        async [GET_USERNAME]({ commit }) {
            const response = await service.getUsername();
            // friendly catch for API errors
            if (response.status === service.ERROR) {
                commit(SHOW_ALERT, { description: response.error });
                return;
            }
            commit(SET_USERNAME, response.data);
        },

        async [LOGOUT]() {
            await mgr.signoutRedirect();
        },
    },
};

export default userState;
